module.exports = __webpack_public_path__ + "img/BG_calcio_2.458fa97d.jpg";